var _path, _polygon, _polygon2, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftCardPana(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.64,96.43l1.7-3.28c14.35-27.68,42.45-45.69,73.35-45.81a80.14,80.14,0,0,1,11.88.82c28.38,4.1,54.15,23.61,66.06,50,7,15.53,9.9,33.77,22,45.65,15.76,15.47,40.67,14.31,62.5,12.16s46.76-3.26,62.46,12.28c9.83,9.73,13.73,24.26,13.92,38.16.53,36.83-22.83,71.36-54.24,89.86s-69.6,22.54-105.67,17.77c-50.53-6.69-99.8-31.09-131.18-71.79S82.94,144,102.64,96.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.18,
    cy: 358.3,
    r: 21.54,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.81,
    y: 405.52,
    width: 73.07,
    height: 10.04,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,415.69H80.69V405.4H154Zm-73.07-.25h72.82v-9.79H80.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.59 412.22 98.11 464.11 137.03 464.11 147.19 415.56 87.59 412.22",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.59 459.2 93.2 466.92 140.5 466.92 147.19 459.2 87.59 459.2",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.61,413.74c-.15,0-.33-24-.41-53.69s0-53.69.1-53.69.33,24,.42,53.69S114.75,413.74,114.61,413.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.88,353.58a2.29,2.29,0,0,1-.19.56c-.17.41-.39.92-.65,1.56-.15.34-.31.71-.48,1.12l-.49,1.36c-.17.49-.36,1-.56,1.57s-.35,1.16-.54,1.78a73.94,73.94,0,0,0-2,9,109,109,0,0,0-1.13,11.19,151.92,151.92,0,0,0,.58,20.43c.24,2.61.47,4.72.65,6.17.07.69.13,1.24.18,1.68a2.19,2.19,0,0,1,0,.59,2.26,2.26,0,0,1-.13-.57c-.08-.44-.17-1-.28-1.67-.24-1.45-.53-3.55-.82-6.16a136.43,136.43,0,0,1-.73-20.5,101.66,101.66,0,0,1,1.18-11.24,67.46,67.46,0,0,1,2.17-9c.2-.62.37-1.23.58-1.78l.6-1.56c.19-.48.36-.94.53-1.36s.36-.77.52-1.11l.74-1.52A3.44,3.44,0,0,1,130.88,353.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,334.14a6.49,6.49,0,0,1-.24.79l-.76,2.24c-.17.49-.35,1-.56,1.61l-.58,1.94c-.43,1.39-.93,3-1.37,4.75-.23.89-.48,1.81-.73,2.78l-.69,3c-.51,2.09-.87,4.36-1.35,6.74-.8,4.77-1.51,10.05-2,15.62s-.66,10.89-.73,15.74,0,9.2.24,12.86c.07,1.84.19,3.49.28,4.94s.17,2.71.27,3.73.13,1.77.18,2.35a4.76,4.76,0,0,1,0,.83,6.91,6.91,0,0,1-.13-.82q-.11-.87-.27-2.34c-.13-1-.25-2.27-.36-3.73s-.27-3.1-.35-4.94c-.25-3.66-.35-8-.36-12.89s.23-10.19.69-15.78,1.22-10.87,2-15.66c.49-2.38.87-4.65,1.4-6.75l.72-3c.27-1,.52-1.89.77-2.78.46-1.78,1-3.35,1.44-4.74.22-.69.43-1.34.63-1.93l.6-1.6c.36-.92.64-1.66.86-2.21A4.18,4.18,0,0,1,129,334.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,418a2.81,2.81,0,0,1,0-.28c0-.22,0-.49-.07-.83-.05-.76-.12-1.83-.21-3.18-.18-2.81-.43-6.8-.73-11.71-.64-9.88-1.55-23.54-3.22-38.56-.85-7.51-1.83-14.64-2.86-21.1-.54-3.23-1-6.3-1.6-9.16s-1.07-5.52-1.58-7.94-1-4.61-1.44-6.52-.83-3.57-1.18-4.91-.57-2.35-.76-3.1q-.11-.49-.18-.81a2.67,2.67,0,0,1,0-.28.86.86,0,0,1,.1.27c.06.21.14.47.24.79.2.74.49,1.77.85,3.08s.81,3,1.26,4.89,1,4.08,1.52,6.51,1.11,5.07,1.65,7.94,1.09,5.93,1.65,9.16c1,6.47,2,13.61,2.9,21.12,1.66,15,2.52,28.71,3.06,38.6.27,4.95.46,8.95.57,11.72,0,1.35.09,2.42.12,3.19,0,.34,0,.61,0,.83A.9.9,0,0,1,110,418Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,317.92c-.32-3.41-3.76-6-7.18-6s-6.61,2-8.7,4.72a27.38,27.38,0,0,0-4.19,9.3c-2.3,8-3.56,16.45-2.58,24.74s4.35,16.45,10.3,22.3c1,1,2.22,1.91,3.55,1.63a4.33,4.33,0,0,0,1.87-1.16,55.39,55.39,0,0,0,18-42.1c-.09-3.16-.51-6.44-2.25-9.06s-5.82-5.42-8.79-4.36",
    style: {
      fill: "#F2A413"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.47,290.64q-2.4,4.37-4.82,8.72c-.11.21-.26.43-.49.45s-.44-.21-.58-.43L69.85,279.84l2.93-1.67Z",
    style: {
      fill: "#F2A413"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.47,290.64q-2.4,4.37-4.82,8.72c-.11.21-.26.43-.49.45s-.44-.21-.58-.43L69.85,279.84l2.93-1.67Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M114.3,306.36,70.86,280.72a2.07,2.07,0,0,1-1.06-1.06,2,2,0,0,1,.78-1.74,29.89,29.89,0,0,1,23.21-9.12,26.5,26.5,0,0,1,21,13.05c4.19,7.49,4.33,17.4-.48,24.51",
    style: {
      fill: "#F2A413"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.12,272.54a2.41,2.41,0,0,1,.57-.07c.38,0,.93-.09,1.64-.08a33.1,33.1,0,0,1,6,.48A35.79,35.79,0,0,1,94,275.48a35.23,35.23,0,0,1,19.53,22.83,33,33,0,0,1,1.08,5.95,11.79,11.79,0,0,1,.06,1.27,2.09,2.09,0,0,1-.33,1,7.55,7.55,0,0,0,.07-2.19,38.05,38.05,0,0,0-1.23-5.87A35.5,35.5,0,0,0,85.3,273.23a37.66,37.66,0,0,0-6-.64C77.91,272.56,77.12,272.59,77.12,272.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.42,288.67a10.59,10.59,0,0,1-2.19,1c-1.39.55-3.32,1.25-5.48,1.93s-4.15,1.24-5.6,1.59a10.42,10.42,0,0,1-2.37.45,12.42,12.42,0,0,1,2.28-.8l5.53-1.73,5.51-1.78A11.48,11.48,0,0,1,108.42,288.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.58,270.29a30.05,30.05,0,0,1,.25,9.71,30.11,30.11,0,0,1-.25-4.85A31.23,31.23,0,0,1,101.58,270.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.48,280.24a19.21,19.21,0,0,1,3.16-1.11c2-.61,4.72-1.38,7.78-2.12s5.87-1.3,7.9-1.66a19.08,19.08,0,0,1,3.32-.45,24.12,24.12,0,0,1-3.25.81c-2,.45-4.79,1.07-7.84,1.81s-5.82,1.45-7.81,2A23.53,23.53,0,0,1,70.48,280.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,310.53c-3.74-2.84-7.69-3.39-12.37-3.21a37.87,37.87,0,0,0-13.54,3.5c-7.33,3.2-14.22,7.93-18.59,14.63S45.58,341,48.85,348.3a3.34,3.34,0,0,0,1.49,1.8,3.54,3.54,0,0,0,2.45-.19c8.33-2.72,16.72-5.46,24.38-9.72S91.81,330,95.92,322.28a15.5,15.5,0,0,0,2-5.95,7.4,7.4,0,0,0-1.91-5.8",
    style: {
      fill: "#F2A413"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.05,309.65a2.59,2.59,0,0,1-.6.24l-1.74.6-1.27.42-1.47.58c-1.06.43-2.28.85-3.57,1.48l-2,.93c-.71.32-1.42.73-2.17,1.11-1.51.74-3,1.69-4.66,2.65a73.17,73.17,0,0,0-18.38,16.17c-1.16,1.49-2.3,2.89-3.23,4.29-.47.69-1,1.34-1.37,2L54.36,342c-.78,1.2-1.36,2.36-1.92,3.35l-.76,1.39c-.2.44-.4.84-.57,1.2l-.82,1.66a2.61,2.61,0,0,1-.32.56,2.94,2.94,0,0,1,.22-.6l.73-1.7c.17-.38.35-.78.54-1.23s.47-.9.73-1.41c.53-1,1.09-2.19,1.86-3.41l1.16-1.93c.41-.67.89-1.33,1.36-2,.92-1.42,2-2.83,3.2-4.34a71.27,71.27,0,0,1,18.51-16.28c1.64-1,3.19-1.89,4.71-2.62.76-.38,1.48-.78,2.2-1.1l2.06-.9c1.31-.61,2.55-1,3.62-1.41.53-.2,1-.39,1.49-.54l1.29-.38,1.77-.51A2.76,2.76,0,0,1,96.05,309.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.86,325.45a87.22,87.22,0,0,1-9.09,2.93,87.29,87.29,0,0,1-9.23,2.43,87.22,87.22,0,0,1,9.09-2.93A90.33,90.33,0,0,1,66.86,325.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.49,345.51a14.78,14.78,0,0,1-.2-2.83c-.05-1.75-.06-4.17,0-6.84s.22-5.09.36-6.84a14.75,14.75,0,0,1,.36-2.81A16.65,16.65,0,0,1,67,329c-.06,1.92-.13,4.25-.21,6.83s-.12,4.91-.17,6.83A16.91,16.91,0,0,1,66.49,345.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.67,336.76c-.14,0-.6-4.91-1-11s-.64-11-.5-11,.6,4.91,1,11S83.81,336.75,83.67,336.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.28,314.28a16.66,16.66,0,0,1,2.92-.09c1.79,0,4.27.06,7,.16s5.22.2,7,.3a16.92,16.92,0,0,1,2.9.28,15.29,15.29,0,0,1-2.91.09c-1.79,0-4.28-.06-7-.15s-5.22-.21-7-.31A16.92,16.92,0,0,1,62.28,314.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.52,374.12a4.5,4.5,0,0,1-.06-.58c0-.44,0-1-.07-1.68-.07-1.45-.09-3.55,0-6.15s.22-5.69.54-9.11.82-7.17,1.53-11.08,1.58-7.59,2.47-10.92,1.84-6.28,2.71-8.73,1.62-4.43,2.19-5.76c.27-.63.49-1.14.66-1.55a2.1,2.1,0,0,1,.27-.52,2.73,2.73,0,0,1-.17.56c-.15.41-.34.93-.57,1.58-.51,1.36-1.21,3.34-2,5.8s-1.71,5.43-2.6,8.74-1.7,7-2.42,10.89-1.2,7.63-1.57,11-.55,6.48-.64,9.07-.15,4.69-.14,6.14c0,.68,0,1.24,0,1.67A2.08,2.08,0,0,1,103.52,374.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.82,345.67a12.78,12.78,0,0,1-1.74,1.91c-1.12,1.12-2.72,2.62-4.54,4.22s-3.52,3-4.78,3.95a12.47,12.47,0,0,1-2.11,1.47,12.58,12.58,0,0,1,1.88-1.76l4.67-4,4.63-4.1A13.5,13.5,0,0,1,105.82,345.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.57,356.75a18.82,18.82,0,0,1-1.85-2.56l-4.29-6.26-4.38-6.21a20.7,20.7,0,0,1-1.76-2.61,16,16,0,0,1,2,2.39c1.2,1.53,2.82,3.69,4.52,6.13S117,352.33,118,354A17.62,17.62,0,0,1,119.57,356.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.36,321.91c.08.13-4.49,3.2-10.2,6.87s-10.4,6.55-10.48,6.43,4.49-3.19,10.2-6.87S112.29,321.79,112.36,321.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.24,335.82a87.25,87.25,0,0,1-6.91-6.39,84.2,84.2,0,0,1-6.54-6.76,87.25,87.25,0,0,1,6.91,6.39A84.2,84.2,0,0,1,125.24,335.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.48,335.54l3.92-.33a19.35,19.35,0,0,0,7.92-2.42,31.85,31.85,0,0,1,3.69-1.86c4.85-1.94,10.26-1.59,15.48-1.86a64,64,0,0,0,24.61-6.29,2.37,2.37,0,0,0,1.08-1c.8-1.47-.69-2.78-2-3.57-6.61-4.07-13.33-8.19-20.82-10.21s-16-1.68-22.39,2.72c-7.51,5.16-10.24,15.77-11.51,24.79",
    style: {
      fill: "#F2A413"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.27,321.32a3.59,3.59,0,0,1-.67-.3l-1.86-1c-1.61-.85-3.93-2.1-6.86-3.5a64.88,64.88,0,0,0-10.63-4.1,35.12,35.12,0,0,0-13.77-1.11,23.53,23.53,0,0,0-12.56,5.39,27.93,27.93,0,0,0-6.53,9.18c-1.38,2.94-2.23,5.44-2.85,7.15l-.7,2a3.82,3.82,0,0,1-.27.68,3.32,3.32,0,0,1,.17-.71c.16-.51.36-1.18.61-2a65.65,65.65,0,0,1,2.7-7.24,27.79,27.79,0,0,1,6.56-9.39,23.75,23.75,0,0,1,12.8-5.55,35.12,35.12,0,0,1,14,1.17A61.74,61.74,0,0,1,176,316.21c2.92,1.45,5.22,2.75,6.8,3.65l1.81,1.06A6.76,6.76,0,0,1,185.27,321.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.85,326.38c-.08.12-5.21-3.19-11.46-7.4s-11.24-7.73-11.16-7.85,5.21,3.2,11.46,7.41S175.93,326.26,175.85,326.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.38,310.86a12.37,12.37,0,0,1-3.74.67,12.84,12.84,0,0,1-3.8,0,22.86,22.86,0,0,1,3.76-.39A25,25,0,0,1,170.38,310.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.93,307.94a10.15,10.15,0,0,1-1.68,2.63,11.5,11.5,0,0,1-2.14,2.42,9.86,9.86,0,0,1,1.69-2.63A11,11,0,0,1,147.93,307.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.52,329.41a14.93,14.93,0,0,1-2.47-1.34c-1.48-.9-3.48-2.22-5.62-3.77s-4-3-5.38-4.1a15.74,15.74,0,0,1-2.13-1.83,15.31,15.31,0,0,1,2.35,1.54l5.47,4c2.13,1.54,4.09,2.9,5.51,3.88A15.24,15.24,0,0,1,152.52,329.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.26,352.2c-3.74-1-8.2,2.65-9,6.44s.65,7.67,2.31,11.16A56.89,56.89,0,0,0,143.07,390c6.7,5.34,15.08,8.75,23.65,8.71-1.58-7.34.42-15-.47-22.48a29.25,29.25,0,0,0-25.89-25.64c-2.39-.25-5.15-.63-6.1,1.58",
    style: {
      fill: "#F2A413"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.72,398.74a2.32,2.32,0,0,1-.54-.25,9.4,9.4,0,0,1-1.39-.94,14.59,14.59,0,0,1-3.7-4.94c-.59-1.15-1.26-2.41-1.91-3.8s-1.31-2.89-2-4.45a42.41,42.41,0,0,0-2.48-4.75,36.33,36.33,0,0,0-3.4-4.63c-2.56-3-5.31-5.61-7.69-8.1a52.54,52.54,0,0,1-5.86-7,26.19,26.19,0,0,1-2.87-5.48c-.24-.68-.41-1.22-.5-1.6a2.25,2.25,0,0,1-.11-.57s.26.76.8,2.1a28.69,28.69,0,0,0,3,5.34,55.8,55.8,0,0,0,5.91,6.91c2.39,2.46,5.15,5.05,7.74,8.09a37.33,37.33,0,0,1,3.44,4.7,40.79,40.79,0,0,1,2.47,4.82c.7,1.57,1.35,3.06,2,4.47s1.28,2.65,1.85,3.82a15.16,15.16,0,0,0,3.5,4.95C166,398.34,166.75,398.69,166.72,398.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.38,392.64a11.13,11.13,0,0,1,.34-2.52c.29-1.54.77-3.66,1.42-6s1.34-4.36,1.9-5.82a11.47,11.47,0,0,1,1-2.33,13.77,13.77,0,0,1-.67,2.45c-.47,1.49-1.1,3.55-1.75,5.84s-1.18,4.38-1.56,5.9A15.25,15.25,0,0,1,147.38,392.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,374.61a15,15,0,0,1-2.64-.61c-1.61-.42-3.83-1-6.31-1.55s-4.73-1-6.37-1.3a16.05,16.05,0,0,1-2.64-.58,12.77,12.77,0,0,1,2.7.21c1.65.22,3.94.6,6.43,1.16s4.71,1.2,6.3,1.71A12.08,12.08,0,0,1,166,374.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.5,379.85a14.67,14.67,0,0,1,.4-2.92c.33-1.78.85-4.24,1.55-6.92s1.45-5.08,2-6.8a16.81,16.81,0,0,1,1.07-2.74,17,17,0,0,1-.72,2.85c-.49,1.75-1.17,4.15-1.87,6.82s-1.28,5.11-1.7,6.87A19.06,19.06,0,0,1,133.5,379.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.43,358.9c0,.14-4.69-.24-10.43-.84a101.39,101.39,0,0,1-10.37-1.37c0-.14,4.68.24,10.43.85S157.44,358.76,157.43,358.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,415.52c0,.15-16.42.26-36.66.26s-36.66-.11-36.66-.26,16.41-.26,36.66-.26S154,415.38,154,415.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.59,436.64c0,.15-11.06.26-24.7.26s-24.7-.11-24.7-.26,11.06-.26,24.7-.26S142.59,436.5,142.59,436.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.16,439.66c0,.15-10.87.26-24.27.26s-24.27-.11-24.27-.26,10.87-.26,24.27-.26S142.16,439.52,142.16,439.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,434.15c0,.15-11.44.26-25.55.26s-25.54-.11-25.54-.26,11.43-.26,25.54-.26S143,434,143,434.15Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.55,467.39c0,.14-85.77.26-191.54.26s-191.56-.12-191.56-.26,85.75-.26,191.56-.26S441.55,467.24,441.55,467.39Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "232.42 453.87 238.41 433.3 213.68 431.29 211.63 455.29 219.02 459.96 232.42 453.87",
    style: {
      fill: "#be8671"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.77 431.18 301.9 466.46 285.71 464.11 284.62 429.46 304.77 431.18",
    style: {
      fill: "#be8671"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.65,457.14s10.87,8.77,16.93,2.33l1.2,3.43,4.76,24.15a3.16,3.16,0,0,1-2.12,3.66,3.22,3.22,0,0,1-3.29-.86c-4.38-4.72-20.44-22.15-20.11-24.32l.5-5.81a3,3,0,0,1,2.13-2.58Z",
    style: {
      fill: "#F2A413"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.85,490.83,283.16,463.5l-.08,1.27c-.23,1.37.35,2,.95,2.89,1.8,2.76,6.87,9,19,22.18a3.21,3.21,0,0,0,2.81,1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.05,460a1.84,1.84,0,0,1,.35,2.46,1.87,1.87,0,0,1-2.5.36,1.78,1.78,0,1,1,2.28-2.7",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.73,477.25c.17.09,1-1.43,2.86-2.15s3.54-.22,3.59-.41-.34-.33-1.05-.48a5,5,0,0,0-2.79.28,4.82,4.82,0,0,0-2.2,1.7C299.74,476.78,299.66,477.22,299.73,477.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.64,481.41c.14.14,1.2-.76,2.82-1.1s3,0,3-.16-1.34-.89-3.18-.48S301.49,481.32,301.64,481.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,471.81c.14.16,1.75-1.24,4.23-2s4.62-.52,4.64-.72-2.2-.73-4.84.09S295.87,471.72,296,471.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,464.57c.07.19,1.82-.39,4-.31s3.93.72,4,.54-1.61-1.14-4-1.2S295.92,464.42,296,464.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.3,464.29a2.56,2.56,0,0,0-.09-1.14,7.92,7.92,0,0,0-1.26-2.86,3.6,3.6,0,0,0-1.73-1.49,1.28,1.28,0,0,0-1.39.42,2,2,0,0,0-.33,1.4,4.47,4.47,0,0,0,4.36,3.59,5.16,5.16,0,0,0,4.75-3.17,1.72,1.72,0,0,0-.08-1.45,1.26,1.26,0,0,0-1.37-.5,4.34,4.34,0,0,0-1.9,1.24,8.79,8.79,0,0,0-1.82,2.54,2.94,2.94,0,0,0-.36,1.08,14.33,14.33,0,0,1,2.51-3.29,4.14,4.14,0,0,1,1.68-1,.68.68,0,0,1,.75.27,1.18,1.18,0,0,1,0,1,4.6,4.6,0,0,1-4.15,2.7,3.89,3.89,0,0,1-3.75-3,1.45,1.45,0,0,1,.19-1,.69.69,0,0,1,.76-.25,3.23,3.23,0,0,1,1.49,1.25A11.23,11.23,0,0,1,301.3,464.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.35,226.17c0,.76,11.62,26.42,11.62,26.42s11.37,26.76,7.23,42.55c-2.28,8.71-14.86,63-14.86,63s-4,41.52-6.18,59.44c-1.81,15-2.28,20.05-2.28,20.05l-20.71-.83-4.32-72.58-1.44-62.92-26,79.2s-5.55,24.47-8.58,34.81-5.44,18-5.44,18l-24.73-2s1.42-25.3,3.44-34.63,5.8-45.16,5.8-45.16l11.39-83h0l7.49-21.58,8.66-22.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.24,452.59l0,1.35s-23.08,8.94-23.37,13.3l45.59.31-.51-15.17C226.13,455.47,219,455.77,211.24,452.59Z",
    style: {
      fill: "#F2A413"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.28,457.2a1.85,1.85,0,0,1,1.27,2.13,1.8,1.8,0,0,1-2.11,1.28,2,2,0,0,1-1.33-2.27,1.86,1.86,0,0,1,2.33-1.09",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.44,467.55l-.12-3.65-43.66,1s-2,.87-1.81,2.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M211.05,454.07c0,.22,1.12.33,2.21,1.05s1.67,1.66,1.88,1.58-.12-1.38-1.46-2.23S211,453.86,211.05,454.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.26,456c0,.22.91.6,1.66,1.55s1,1.94,1.18,1.93.37-1.26-.58-2.42S206.27,455.8,206.26,456Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.5,461.72c.21,0,.52-1.07,0-2.29s-1.6-1.71-1.7-1.53.55.84,1,1.85S203.28,461.69,203.5,461.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.36,285.46a2.29,2.29,0,0,1,0,.39c0,.29-.08.67-.13,1.15-.13,1-.31,2.51-.54,4.4-.48,3.82-1.15,9.36-1.93,16.2-1.56,13.68-3.43,32.61-4.61,53.59-.57,10.49-.92,20.49-1.11,29.59s-.2,17.3-.14,24.19.15,12.45.25,16.3c0,1.9.07,3.39.09,4.43v1.16a2.87,2.87,0,0,1,0,.39,2.33,2.33,0,0,1,0-.39c0-.28,0-.67-.06-1.15,0-1-.1-2.53-.18-4.43-.17-3.85-.31-9.42-.42-16.31s-.13-15.09,0-24.2.49-19.11,1.07-29.61c1.18-21,3.11-39.93,4.76-53.61.83-6.83,1.55-12.36,2.1-16.17.27-1.89.49-3.36.64-4.39.07-.48.13-.86.17-1.14A3.06,3.06,0,0,1,303.36,285.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.86,281.13a2,2,0,0,1,0,.4c0,.3,0,.69,0,1.19-.05,1.07-.11,2.61-.19,4.57-.17,4-.41,9.72-.71,16.78-.56,14.18-1.18,33.76-1.45,55.41s-.1,41.24.15,55.43c.16,7.07.28,12.8.37,16.79,0,2,.07,3.5.1,4.57,0,.5,0,.9,0,1.19a2.38,2.38,0,0,1,0,.4,1.51,1.51,0,0,1,0-.4c0-.29,0-.69-.07-1.19,0-1.07-.11-2.6-.2-4.56-.17-4-.35-9.7-.53-16.79-.35-14.19-.57-33.79-.3-55.45s1-41.24,1.61-55.41c.32-7.09.62-12.82.86-16.78.13-2,.22-3.49.29-4.56,0-.51.07-.9.09-1.19A1.73,1.73,0,0,1,289.86,281.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.84,285.47a2,2,0,0,1-.06.4l-.21,1.14c-.21,1-.5,2.5-.87,4.39-.78,3.8-1.86,9.32-3.14,16.14s-2.71,15-4.15,24-2.87,19.05-4.16,29.57-2.28,20.56-3.08,29.71-1.34,17.4-1.75,24.33-.68,12.54-.84,16.42c-.09,1.92-.16,3.42-.21,4.47,0,.49-.05.88-.06,1.16a1.87,1.87,0,0,1-.05.4s0-.14,0-.4,0-.67,0-1.16c0-1.05.06-2.55.11-4.47.1-3.89.32-9.5.67-16.44s.89-15.2,1.64-24.35,1.76-19.21,3-29.74,2.75-20.51,4.2-29.58,2.95-17.21,4.27-24,2.46-12.32,3.3-16.12c.41-1.87.74-3.34,1-4.36.11-.48.19-.86.26-1.14A1.87,1.87,0,0,1,319.84,285.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.74,283.61a2,2,0,0,1-.11.39c-.09.28-.2.66-.35,1.14-.34,1-.81,2.48-1.42,4.34l-5.3,15.95c-4.47,13.49-10.64,32.08-17.44,52.62s-12.78,39.21-17.18,52.72c-2.18,6.73-3.95,12.19-5.19,16-.61,1.86-1.09,3.32-1.43,4.34-.16.47-.29.84-.38,1.12a2.47,2.47,0,0,1-.15.38,1.64,1.64,0,0,1,.1-.39l.33-1.14c.32-1,.77-2.5,1.34-4.37,1.2-3.82,2.91-9.29,5-16,4.28-13.53,10.27-32.19,17-52.77s13-39.15,17.59-52.58c2.3-6.69,4.16-12.11,5.45-15.89l1.52-4.32.4-1.11A3.09,3.09,0,0,1,278.74,283.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.78,285.38a3.93,3.93,0,0,1-.06.39l-.24,1.11c-.22,1-.54,2.45-.94,4.29L254,306.91c-3,13.32-7.06,31.68-11.59,52s-8.65,38.67-11.73,51.94l-3.7,15.7c-.45,1.83-.8,3.26-1,4.27l-.29,1.1a1.87,1.87,0,0,1-.11.38,1.78,1.78,0,0,1,.06-.39l.24-1.12c.22-1,.53-2.44.94-4.28.84-3.75,2.05-9.12,3.54-15.74,3-13.33,7.06-31.69,11.59-52s8.65-38.66,11.73-51.93c1.56-6.61,2.82-12,3.7-15.71.45-1.83.8-3.26,1-4.26l.28-1.11A2.3,2.3,0,0,1,258.78,285.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.64,284.94a2.29,2.29,0,0,1,0,.39c0,.27-.06.64-.11,1.12-.11,1-.27,2.45-.47,4.3-.45,3.76-1.08,9.15-1.86,15.81-1.6,13.34-3.87,31.77-6.79,52.07s-6.07,38.61-8.56,51.81c-1.26,6.61-2.3,11.94-3.07,15.62-.39,1.82-.68,3.24-.89,4.24-.11.46-.19.82-.25,1.1a2.63,2.63,0,0,1-.1.37,2.18,2.18,0,0,1,0-.38c.05-.28.11-.65.19-1.11.19-1,.46-2.43.8-4.26l2.9-15.64c2.41-13.22,5.49-31.53,8.42-51.83s5.24-38.71,6.94-52c.85-6.64,1.53-12,2-15.79.25-1.84.44-3.28.58-4.29.06-.47.12-.83.16-1.11A2.41,2.41,0,0,1,241.64,284.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.41,355.27s17.29-11.2,30.11,2C311.52,357.25,293.84,365.67,281.41,355.27Z",
    style: {
      fill: "#be8671"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.77,100a1.93,1.93,0,0,1-.78-3.2c-1-.54-.7-2.09.06-2.9s1.87-1.31,2.46-2.26a2.29,2.29,0,0,1-2.74-2,1.87,1.87,0,0,1-1.18-3.43c-1.05-.09-1-1.82-.08-2.4s2-.54,3-1A12.38,12.38,0,0,1,259.05,79l-4.29-3.19a2.5,2.5,0,0,1-.86-.91c-.37-.85.3-1.79,1-2.4a10,10,0,0,1,5.33-2.32c.62-.08,1.42,0,1.62.62a9,9,0,0,1,4.35-.49,3.49,3.49,0,0,1,2.31.7A6.82,6.82,0,0,0,267,69.12,3,3,0,0,1,266,67c.08-.82,1.07-1.53,1.75-1.07-.76-.35-.66-1.58,0-2.11a3.81,3.81,0,0,1,2.4-.6c.59,0,1.34.08,1.5.64a1.64,1.64,0,0,1,3-.24,2,2,0,0,1,2.93.23,2.61,2.61,0,0,1,3.69,1.37l-2.28-3.82c-.43-.72-.5-2.07.33-2-1.2,0-1.88-1.64-1.3-2.68a3.11,3.11,0,0,1,3.13-1.3l1,1.51a2.37,2.37,0,0,1,3.63,2.64,1.21,1.21,0,0,1,1.8.36,3.57,3.57,0,0,1,.35,2.05,2,2,0,0,1,3.14,1.68,6.64,6.64,0,0,1,3.44-.72,2.33,2.33,0,0,1,3-3.31,2.3,2.3,0,0,1,3-1.87c.37-1.39,2.19-2.42,3.3-1.5s.53,2.79-.17,4.1-1.53,2.84-2.29,4.27l7.45-4a1.33,1.33,0,0,1,.74-.22c.36,0,.62.37.94.54a10.17,10.17,0,0,0,1.48.26c1.31.4,1.29,2.41.39,3.44s-2.28,1.54-3.3,2.46l3.31.63a3.39,3.39,0,0,1,4.37-2.29c.45-1.22,2.09-1.38,3.39-1.32a4.71,4.71,0,0,1,3.27,1,3.24,3.24,0,0,1,0,4.1,9.48,9.48,0,0,1-3.62,2.56c.22,1,1.51,1.29,2.51,1.14s2.05-.54,3-.18c1.29.49,1.84,2.15,3.14,2.63a5.27,5.27,0,0,1,1.18.39,2.31,2.31,0,0,1,.79,1.54c.17.72.33,1.43.49,2.15a2.63,2.63,0,0,1,.09,1.08c-.24,1.17-1.87,1.42-3,1s-2.05-1.32-3.23-1.5c1.55.78,3.2,1.63,4.06,3.14s.52,3.84-1.12,4.42-3.28-.83-4.49-2.11-2.93-2.65-4.53-1.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.16,99a2.12,2.12,0,0,0-3.2,1.85,4.42,4.42,0,0,0-1.66,7.65c1,.83,2.92.86,3.12-.4a3.47,3.47,0,0,0,2.45,2.12,3.34,3.34,0,0,0,1.35,4.74,3.56,3.56,0,0,0,.61,5.9,2.73,2.73,0,1,0,5,2.23,5.77,5.77,0,0,0,1.81,2.72,2,2,0,0,0,2.88-.49,3.75,3.75,0,0,0,5.33,2.25,2.43,2.43,0,0,0,4.77.83l6.24.48A22.14,22.14,0,0,0,287,129a11.14,11.14,0,0,0,4.94-1.79,3.76,3.76,0,0,1,1.51-.75,3.82,3.82,0,0,1,1.88.46,10.14,10.14,0,0,0,9.78-1.44,4.88,4.88,0,0,1,1.36-.9,4.46,4.46,0,0,1,1.86-.1,18.11,18.11,0,0,0,4.59-.26,4.85,4.85,0,0,0,3.37-1.82c.7-1.12.16-3-1.16-3.08A2.84,2.84,0,0,1,316,117a1.71,1.71,0,0,1,2.31.1,1.23,1.23,0,0,1-.73,1.94c1.33,1.1,3.63-.08,3.82-1.79a3.39,3.39,0,0,0-3.11-3.44,7.76,7.76,0,0,0,.42-3.76,2.78,2.78,0,0,0,3.74.76,4.82,4.82,0,0,0,2.9,2.49,2.88,2.88,0,0,0,3.31-1.46A2.07,2.07,0,0,0,327,109a2.48,2.48,0,0,0-1.88-3.76,3.85,3.85,0,0,0-2-4.27,2,2,0,0,0,3-.86c.68,1.32,2.64,1.18,4,.54,1.06-.5,2.09-1.26,1.93-2.78A3.06,3.06,0,0,0,331,96c-1.23-1.17-2.95-1.38-4.58-1.57A19.65,19.65,0,0,1,325.05,88a3.84,3.84,0,0,0,4.17-2.77l-9-5.62s-20.92-3.23-21.67-3.23S254,98.93,254,98.93c-1,1.06-3,.58-3.73-.68a4,4,0,0,1,.35-4.15,11.78,11.78,0,0,1,3.2-3,5.93,5.93,0,0,1-3.93-1.25,2.22,2.22,0,0,1-.6-2.42c.5-1.2,1.9-1.12,2.79-1.8a5.11,5.11,0,0,0,1.15-1.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.45,146c0,.39-6.27-4.82-6.27-4.82v-1.81c0-4.52,0-6.38,0-6.34s9.54-1.65,11.43-14.12c.94-6.2.56-16.35,0-24.65-.52-7.47-5.53-16.61-13-15.77l-23.21,6A4.37,4.37,0,0,0,272.52,89l2.38,50.13-5.41,2.69,6.59,12.67,17.28,3,14.76,1.19-.86-7.81.19-4.91Z",
    style: {
      fill: "#be8671"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.87,101.93a1.6,1.6,0,0,1-1.53,1.62,1.53,1.53,0,0,1-1.65-1.43,1.59,1.59,0,0,1,1.53-1.62A1.51,1.51,0,0,1,308.87,101.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.43,99.55c-.2.21-1.42-.68-3.14-.67s-3,.89-3.16.68.11-.47.66-.87a4.27,4.27,0,0,1,2.53-.8,4.2,4.2,0,0,1,2.49.78C310.34,99.08,310.52,99.45,310.43,99.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.44,102.83c-.2.21-1.42-.68-3.13-.66s-3,.88-3.16.67.1-.47.65-.87a4.39,4.39,0,0,1,2.53-.8,4.2,4.2,0,0,1,2.49.79C293.35,102.36,293.54,102.73,293.44,102.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.86,112.69a11.23,11.23,0,0,1,2.78-.53c.44,0,.86-.13.93-.43a2.29,2.29,0,0,0-.3-1.3L302,107.09c-1.84-4.74-3.17-8.65-3-8.72s1.84,3.72,3.67,8.46c.44,1.17.87,2.29,1.27,3.36a2.53,2.53,0,0,1,.24,1.72,1.12,1.12,0,0,1-.72.65,3.09,3.09,0,0,1-.74.1A11,11,0,0,1,299.86,112.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.18,133a31.69,31.69,0,0,1-16.71-4.33s4.25,8.65,16.71,7.4Z",
    style: {
      fill: "#a24c2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.06,116.56a4.39,4.39,0,0,0-3.57-1.89,2.63,2.63,0,0,0-2.21,4.12,2.7,2.7,0,0,0,2.85,1,6.36,6.36,0,0,0,2.56-1.61,1.92,1.92,0,0,0,.54-.66.91.91,0,0,0-.08-.9",
    style: {
      fill: "#a24c2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.81,113.91c.27,0,.29,1.85,1.9,3.16s3.59,1.1,3.6,1.36c0,.11-.44.36-1.28.39a4.64,4.64,0,0,1-3-1,4.06,4.06,0,0,1-1.47-2.66C294.47,114.36,294.68,113.9,294.81,113.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.28,98c-.16.47-1.88.26-3.9.52s-3.64.81-3.91.4c-.12-.2.16-.64.82-1.1a6.51,6.51,0,0,1,2.89-1,6.62,6.62,0,0,1,3.06.34C294,97.4,294.35,97.77,294.28,98Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.76,94.57c-.3.4-1.49,0-2.91,0s-2.63.28-2.91-.13c-.12-.19.07-.59.59-1a4,4,0,0,1,2.36-.65,4.05,4.05,0,0,1,2.33.76C309.72,94,309.89,94.38,309.76,94.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.46,101.76a2.08,2.08,0,0,0,.6,2.39,1.44,1.44,0,0,0,2-.57c.54.73,1.79,0,1.62-1,.67.38,1.56-.52,1.34-1.37.78.3,1.25-1,1.66-1.8a14,14,0,0,1,.81-1.29,8.7,8.7,0,0,0,1.29-4.7c1-1.15,1.28-2.94,1.49-4.6l.39-3.1.58-.72a1.71,1.71,0,0,0,1.11,1.62,3.63,3.63,0,0,0,1.88,0l1.86-.35,1.15.34a4.75,4.75,0,0,0,.33,3,2.93,2.93,0,0,0,1.07,1.69.87.87,0,0,0,1.22-.93,1,1,0,0,0,1.51-.24,3.2,3.2,0,0,0,.42-1.91,8.13,8.13,0,0,0-1.47-4.5l3.21,3a1.46,1.46,0,0,0,.79.49.85.85,0,0,0,.9.94,2.18,2.18,0,0,0,1.2-.8c.78-.82,1.62-2.22.93-3.15a.7.7,0,0,0,.31-1l3.64,2.8c-.36-.21-.77.35-.69.82a1.9,1.9,0,0,0,.76,1.09,2.87,2.87,0,0,0-.43,1.73c-.65-.59-1.65.5-1.44,1.44a2.07,2.07,0,0,0,1.93,1.52,1.43,1.43,0,0,0,1.63-1.06c.8.18,1.58-.92,1.3-1.83.58.39,1.09-.65,1.13-1.44a11.48,11.48,0,0,0-.62-4.25c0,.2.2.38.34.27a.32.32,0,0,0-.05-.49l2,5a11.73,11.73,0,0,1,1.11,4.19c0,.6.08,1.42.58,1.48a.82.82,0,0,0,.4-.1,7.55,7.55,0,0,0,3.31-3.82,5.92,5.92,0,0,0,.51-1.77c.12-1.28-.41-2.53-.5-3.82a12.13,12.13,0,0,0-.11-1.7,5.14,5.14,0,0,0-1.31-2.23c-2-2.28-4-4.65-6.67-5.58-1.61-.56-3.33-.55-4.94-1.1a27.16,27.16,0,0,1-2.9-1.35c-4-1.88-8.38-2.13-12.65-1.78a20.37,20.37,0,0,0-7,1.63,24.36,24.36,0,0,0-6.6,5,37.35,37.35,0,0,0-7.77,10.39,18.33,18.33,0,0,0-1.87,10.29c.51,3.52,2.69,6.83,5.64,7.57l1.16-1.33",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.87,104.15c-.17-.08-6.94-2.23-6.87,4.72s7,5.46,7,5.26S275.87,104.15,275.87,104.15Z",
    style: {
      fill: "#be8671"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.89,111.52s-.12.08-.33.18a1.18,1.18,0,0,1-.9,0,3,3,0,0,1-1.41-2.67,3.89,3.89,0,0,1,.32-1.74,1.43,1.43,0,0,1,.9-.94.61.61,0,0,1,.72.33c.1.19.05.33.09.34s.15-.12.09-.4a.78.78,0,0,0-.28-.44.92.92,0,0,0-.67-.17,1.7,1.7,0,0,0-1.25,1.09,4.19,4.19,0,0,0-.41,1.94c.06,1.4.79,2.71,1.8,3a1.32,1.32,0,0,0,1.1-.19C273.88,111.68,273.91,111.53,273.89,111.52Z",
    style: {
      fill: "#a24c2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.61,102a16.29,16.29,0,0,0-.32-2,8.25,8.25,0,0,0-3-4.46,8.15,8.15,0,0,0-7.68-1.14,7.83,7.83,0,0,0-2.05,1.1,7.71,7.71,0,0,0-1.7,1.72,8,8,0,0,0,0,9.56,7.71,7.71,0,0,0,1.7,1.72,7.58,7.58,0,0,0,2.05,1.11,8.1,8.1,0,0,0,7.68-1.15,8.18,8.18,0,0,0,3-4.46,15.67,15.67,0,0,0,.32-2,3.54,3.54,0,0,1,0,.53,3.13,3.13,0,0,1-.05.64,5.38,5.38,0,0,1-.15.86,8.21,8.21,0,0,1-3,4.61,8.34,8.34,0,0,1-3.51,1.59,8.48,8.48,0,0,1-4.4-.35,8.29,8.29,0,0,1-2.13-1.14,7.87,7.87,0,0,1-1.77-1.78,8.32,8.32,0,0,1,0-9.92,8.35,8.35,0,0,1,3.9-2.91,8.29,8.29,0,0,1,10.9,5.84,5.48,5.48,0,0,1,.15.87,3,3,0,0,1,.05.63A3.54,3.54,0,0,1,298.61,102Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.23,102a16.29,16.29,0,0,0-.32-2,8.27,8.27,0,0,0-3-4.46,8.12,8.12,0,0,0-7.67-1.14,8.06,8.06,0,0,0-3.76,2.82,8.06,8.06,0,0,0,0,9.56,7.75,7.75,0,0,0,1.71,1.72,7.58,7.58,0,0,0,2.05,1.11,8.22,8.22,0,0,0,4.25.36,8.11,8.11,0,0,0,3.42-1.51,8.21,8.21,0,0,0,3-4.46,15.67,15.67,0,0,0,.32-2,3.54,3.54,0,0,1,0,.53,4.05,4.05,0,0,1-.05.64,5.38,5.38,0,0,1-.15.86,8.32,8.32,0,0,1-6.5,6.2,8.48,8.48,0,0,1-4.4-.35,8,8,0,0,1-2.13-1.14,7.71,7.71,0,0,1-1.78-1.78,8.36,8.36,0,0,1,0-9.92,8.31,8.31,0,0,1,3.91-2.91A8.29,8.29,0,0,1,318,100a5.48,5.48,0,0,1,.15.87,3.94,3.94,0,0,1,.05.63A3.54,3.54,0,0,1,318.23,102Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.1,100.09c0,.08-.83-.24-1.86-.27s-1.85.23-1.88.14a2.8,2.8,0,0,1,1.89-.45A2.77,2.77,0,0,1,302.1,100.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.07,102.84a13.65,13.65,0,0,1-3.48.88A13.83,13.83,0,0,1,275,104c0-.1,1.58-.25,3.52-.57S282,102.75,282.07,102.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.74,100.73a4.51,4.51,0,0,1-.08,1.55,9.86,9.86,0,0,1-1.37,3.5,8.37,8.37,0,0,1-2.62,2.7,1.89,1.89,0,0,1-1.52.33,3.67,3.67,0,0,0,1.4-.52,9.32,9.32,0,0,0,2.47-2.68,11.12,11.12,0,0,0,1.42-3.37C297.65,101.31,297.69,100.72,297.74,100.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.68,106a11,11,0,0,1,.67-1.3,5.94,5.94,0,0,0,.54-1.45,4.86,4.86,0,0,0,0-1.87,9.93,9.93,0,0,0-1-3.32c-.42-.78-.85-1.15-.8-1.2a1.16,1.16,0,0,1,.32.24,4.64,4.64,0,0,1,.67.85,8.76,8.76,0,0,1,1.11,3.38,5.08,5.08,0,0,1-.06,2,6.11,6.11,0,0,1-.64,1.49A5.07,5.07,0,0,1,315.68,106Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,113.89s-.18.09-.45.29a2.33,2.33,0,0,0-.8,1.17,2,2,0,0,0,.42,1.94,2.34,2.34,0,0,0,2.32.67,2.51,2.51,0,0,0,1.64-1.8,2.47,2.47,0,0,0-.39-2,3.06,3.06,0,0,0-1.06-1c-.3-.17-.49-.22-.48-.25a1.33,1.33,0,0,1,.54.14,2.87,2.87,0,0,1,1.18,1,2.66,2.66,0,0,1,.49,2.2,2.77,2.77,0,0,1-1.84,2,2.63,2.63,0,0,1-2.62-.79,2.17,2.17,0,0,1-.52-1.13,2.33,2.33,0,0,1,.11-1.07,2.24,2.24,0,0,1,.94-1.2A1.11,1.11,0,0,1,271,113.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.8,82.08a1.75,1.75,0,0,0,.47-.9,1.23,1.23,0,0,0-.31-1,1.32,1.32,0,0,0-1.33-.35l-.29.1.12-.28a1.37,1.37,0,0,0-.36-1.54,1.35,1.35,0,0,0-1.73.06l-.23-.21a.77.77,0,0,0,.1-.18.83.83,0,0,0-.11-.65.91.91,0,0,0-.57-.36,1.51,1.51,0,0,0-.7,0,1.77,1.77,0,0,1-.78.17c-.33-.06-.48-.3-.65-.41a2.17,2.17,0,0,0-.53-.34,3,3,0,0,0-1.12-.25,3.09,3.09,0,0,0-1.62.38c-.35.21-.51.37-.53.35a1.35,1.35,0,0,1,.46-.45,3,3,0,0,1,1.69-.51,3.26,3.26,0,0,1,1.22.24,2.45,2.45,0,0,1,.6.36c.21.14.36.33.53.35a2.08,2.08,0,0,0,.65-.18,1.7,1.7,0,0,1,.84,0,1.16,1.16,0,0,1,.76.48,1.09,1.09,0,0,1,.16.93,1,1,0,0,1-.16.28l-.23-.22a1.6,1.6,0,0,1,2.56,1.82l-.17-.18a1.54,1.54,0,0,1,1.58.45,1.44,1.44,0,0,1-.08,1.93C299.9,82.05,299.81,82.09,299.8,82.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.57,84.09a2.22,2.22,0,0,0,.59-.87,1.56,1.56,0,0,0-.07-1.17,1.61,1.61,0,0,0-1.22-.89l-.23,0,.15-.17a1.93,1.93,0,0,0,.54-1.7,1,1,0,0,0-.63-.7.81.81,0,0,0-.92.12l-.89.94.65-1.12a1.65,1.65,0,0,0,.09-1.36,1.49,1.49,0,0,0-1.08-.92,1.61,1.61,0,0,0-1,.1l-.36.18.15-.38c.21-.53-.33-1.15-.87-1.22a2.6,2.6,0,0,0-1.65.41l-.3.16.09-.33A1.14,1.14,0,0,0,300.2,74a2.16,2.16,0,0,0-1.07-.47,5.41,5.41,0,0,0-2,0,8.36,8.36,0,0,0-1.68.61s.12-.12.39-.28a5.13,5.13,0,0,1,1.25-.49,5.28,5.28,0,0,1,2.07-.11,2.33,2.33,0,0,1,1.21.51,1.43,1.43,0,0,1,.47,1.38l-.21-.16a2.88,2.88,0,0,1,1.84-.46,1.44,1.44,0,0,1,.91.54,1.11,1.11,0,0,1,.2,1.1l-.21-.2a1.85,1.85,0,0,1,1.25-.13A1.81,1.81,0,0,1,305.92,77a1.91,1.91,0,0,1-.12,1.62l-.24-.18a1.12,1.12,0,0,1,1.26-.18,1.35,1.35,0,0,1,.78.9,2.18,2.18,0,0,1-.63,1.93l-.07-.2a1.82,1.82,0,0,1,1.36,1,1.68,1.68,0,0,1,0,1.3,1.65,1.65,0,0,1-.48.67C307.67,84.06,307.57,84.1,307.57,84.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.31,85.55a1.18,1.18,0,0,0-.4-.86,1.49,1.49,0,0,0-1-.37,4.36,4.36,0,0,0-1.49.35l-.17.06,0-.18a1.34,1.34,0,0,0-1.1-1.31,3.87,3.87,0,0,0-2.21.35L317,84l.83-.62a1.11,1.11,0,0,0-.08-1.59,2.57,2.57,0,0,0-1.95-.46h-.09l-.62.06.52-.35a1.18,1.18,0,0,0-.14-1.87,1.79,1.79,0,0,0-2,.19l-.64.5.43-.69a2.71,2.71,0,0,0,0-2.74,2.52,2.52,0,0,0-1.85-1.17,2.83,2.83,0,0,0-1.47.18c-.32.14-.47.26-.49.24a.72.72,0,0,1,.1-.1,2.18,2.18,0,0,1,.35-.22,2.86,2.86,0,0,1,1.53-.28,2.67,2.67,0,0,1,2,1.23,2.94,2.94,0,0,1,.05,3l-.22-.19a2.09,2.09,0,0,1,2.35-.22,1.53,1.53,0,0,1,.68,1.14,1.35,1.35,0,0,1-.54,1.26l-.1-.29h.1a2.76,2.76,0,0,1,2.18.55,1.59,1.59,0,0,1,.47,1,1.17,1.17,0,0,1-.42,1l-.14-.26a4.12,4.12,0,0,1,2.38-.33,1.58,1.58,0,0,1,1.25,1.6l-.15-.12a4.43,4.43,0,0,1,1.56-.32,1.61,1.61,0,0,1,1.12.46,1.13,1.13,0,0,1,.35.68C324.35,85.46,324.32,85.55,324.31,85.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.54,69.6s-.13.09-.41.15a5.22,5.22,0,0,1-1.22.07,3.49,3.49,0,0,0-1.75.26,1.1,1.1,0,0,0-.61.76.81.81,0,0,0,.32.92l-.22.15c-.06-.4-.56-.66-1-.92a5.15,5.15,0,0,0-1.46-.64,1.91,1.91,0,0,0-1.49.23,1.27,1.27,0,0,0-.65,1.16l0,.38-.29-.25a3.51,3.51,0,0,0-2.05-.85,3.92,3.92,0,0,0-1.75.26,5,5,0,0,0-1.34.85,1.46,1.46,0,0,1,.26-.34,3.48,3.48,0,0,1,1-.68,3.91,3.91,0,0,1,1.84-.33,3.69,3.69,0,0,1,2.22.87l-.24.13a1.56,1.56,0,0,1,.77-1.46,2.2,2.2,0,0,1,1.72-.27,7.45,7.45,0,0,1,2.24,1.11,1.11,1.11,0,0,1,.46.7l.05.3-.26-.14a1.09,1.09,0,0,1-.45-1.25,1.34,1.34,0,0,1,.77-.91,3.55,3.55,0,0,1,1.87-.22,7,7,0,0,0,1.19,0C315.39,69.63,315.53,69.59,315.54,69.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,63.59a2.94,2.94,0,0,0-.83.11,2.09,2.09,0,0,0-.78.5,1.74,1.74,0,0,0-.5,1l0,.17-.16,0a1,1,0,0,0-1.14.64,3.12,3.12,0,0,0-.06,1.73l.09.61-.38-.5-.06-.08a1.33,1.33,0,0,0-1.08-.45,1.46,1.46,0,0,0-1,.45,2.36,2.36,0,0,0-.63,1.85,4.08,4.08,0,0,0,.35,1.35,2,2,0,0,1,.19.5,1.71,1.71,0,0,1-.3-.44,3.93,3.93,0,0,1-.46-1.39,2.57,2.57,0,0,1,.64-2.08,1.77,1.77,0,0,1,2.56,0l.07.1-.28.11a3.24,3.24,0,0,1,.1-1.9,1.3,1.3,0,0,1,1.5-.77l-.18.12a2,2,0,0,1,.62-1.19,2.1,2.1,0,0,1,.89-.49,1.49,1.49,0,0,1,.65,0C299.94,63.54,300,63.57,300,63.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.31,73.1s-.16,0-.41-.09a2.6,2.6,0,0,1-.95-.67,2.91,2.91,0,0,1-.72-1.58,1.43,1.43,0,0,0-.2-.85c-.18-.22-.56-.36-.8-.72a1.57,1.57,0,0,1,.41-2.12l0,.23a5,5,0,0,1-1.34-1.86,2.16,2.16,0,0,1-.22-.86,7.33,7.33,0,0,1,.38.79,5.67,5.67,0,0,0,1.37,1.71l.15.13-.17.1a1.3,1.3,0,0,0-.3,1.7c.16.27.51.4.77.7a1.6,1.6,0,0,1,.26,1,2.67,2.67,0,0,0,.6,1.45A3.88,3.88,0,0,0,286.31,73.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.27,75.86a.9.9,0,0,1-.26,0,3.12,3.12,0,0,1-.74-.06A4.23,4.23,0,0,1,279,74.51h.2a2.69,2.69,0,0,1-1.84,1,2.64,2.64,0,0,1-1.17-.14,1.69,1.69,0,0,1-1-.78,4.46,4.46,0,0,1-.12-.45.63.63,0,0,0-.2-.29,1.89,1.89,0,0,0-.72-.32,2.71,2.71,0,0,1-.81-.33.9.9,0,0,1-.44-.78l.19.14a2.8,2.8,0,0,1-1.91,0,3,3,0,0,1-1.26-.79,2.66,2.66,0,0,1-.52-.81c-.07-.21-.09-.33-.07-.33a3.72,3.72,0,0,0,.71,1,3,3,0,0,0,1.21.68,2.54,2.54,0,0,0,1.73-.08l.21-.09v.23a.6.6,0,0,0,.33.51,2.12,2.12,0,0,0,.72.28,2.17,2.17,0,0,1,.84.38,1,1,0,0,1,.3.44,3.83,3.83,0,0,0,.11.41,1.38,1.38,0,0,0,.82.62,2.5,2.5,0,0,0,2.7-.71l.1-.12.1.12a4.32,4.32,0,0,0,2.15,1.34C281.91,75.84,282.27,75.82,282.27,75.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.5,85.5s0,0,0-.11a1.65,1.65,0,0,1,0-.32,3.44,3.44,0,0,1,.15-1.25,7.48,7.48,0,0,1,.84-1.76,7.31,7.31,0,0,1,.7-1,2,2,0,0,1,.55-.42.87.87,0,0,1,.77,0l-.2.13a2.16,2.16,0,0,1,1-2,2.14,2.14,0,0,1,2.42.17l-.25.12a1.43,1.43,0,0,1,.58-1.17,1.4,1.4,0,0,1,1.34-.17,1.51,1.51,0,0,1,.62.47l-.29.11a.92.92,0,0,1,.34-.74,1.19,1.19,0,0,1,.7-.3,2.85,2.85,0,0,1,1.35.35l-.2.06a2.26,2.26,0,0,1,1.36-1,3.09,3.09,0,0,1,1.54,0,7.84,7.84,0,0,1,2.37,1.18l-.17.14a.54.54,0,0,1,.07-.55,1,1,0,0,1,.38-.29,1.68,1.68,0,0,1,.84-.13,4.64,4.64,0,0,1,1.25.38,3.67,3.67,0,0,1,.71.42c.15.11.22.18.21.19a10,10,0,0,0-1-.5,4.8,4.8,0,0,0-1.22-.31,1.47,1.47,0,0,0-.73.13c-.24.11-.44.33-.33.57l.17.34-.33-.2A8.12,8.12,0,0,0,270.65,77a2.89,2.89,0,0,0-1.4,0,2,2,0,0,0-1.18.82L268,78l-.12-.06a2.61,2.61,0,0,0-1.19-.31c-.38,0-.78.34-.75.7l.05.55-.34-.44a1.08,1.08,0,0,0-.47-.37,1.1,1.1,0,0,0-1,.13,1.12,1.12,0,0,0-.46.91v.34l-.27-.21a1.83,1.83,0,0,0-2.07-.16,1.89,1.89,0,0,0-.87,1.71l0,.26-.22-.13c-.34-.2-.75.07-1,.35a7.28,7.28,0,0,0-.69.94,7.5,7.5,0,0,0-.88,1.7A4.18,4.18,0,0,0,257.5,85.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.25,94.69s-.06-.06-.16-.19a5.6,5.6,0,0,1-.37-.64,2.34,2.34,0,0,1-.25-1.15,1.67,1.67,0,0,1,.24-.71,1.17,1.17,0,0,1,.69-.53l-.07.17a1.47,1.47,0,0,1,1.57-2.25l-.14.22a1.19,1.19,0,0,1,0-1.4,1.77,1.77,0,0,1,1.34-.62,5.42,5.42,0,0,0,.7,0,.61.61,0,0,0,.44-.38,2.56,2.56,0,0,1,.4-.68,1.39,1.39,0,0,1,.74-.4,8,8,0,0,1,1.68,0,1.79,1.79,0,0,0,1.35-.4,5.19,5.19,0,0,0,.43-.6,1.67,1.67,0,0,1,.64-.48,1.62,1.62,0,0,1,1.47.08l-.19.19a1.27,1.27,0,0,1,.17-1.45,1.8,1.8,0,0,1,1.18-.58,5.44,5.44,0,0,1,2.05.26,6.73,6.73,0,0,1,1.23.49,1.49,1.49,0,0,1,.4.25s-.58-.3-1.67-.59a5.55,5.55,0,0,0-2-.18,1.5,1.5,0,0,0-1,.51,1,1,0,0,0-.14,1.14l.33.49-.51-.3a1.41,1.41,0,0,0-1.22,0,1.27,1.27,0,0,0-.51.41c-.14.18-.25.41-.45.63a1.64,1.64,0,0,1-.74.41,3.38,3.38,0,0,1-.83.08,8.6,8.6,0,0,0-1.61,0,1.11,1.11,0,0,0-.58.32,2.89,2.89,0,0,0-.36.61.89.89,0,0,1-.65.53,6.43,6.43,0,0,1-.75,0,1.45,1.45,0,0,0-1.11.49.89.89,0,0,0-.06,1l.25.32-.4-.1a1.21,1.21,0,0,0-1.31,1.85l.08.14-.15,0a1.21,1.21,0,0,0-.8,1,2.27,2.27,0,0,0,.18,1.09C259.08,94.39,259.28,94.68,259.25,94.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.78,113.81a.74.74,0,0,1-.31-.1,2.21,2.21,0,0,1-.71-.56,2.25,2.25,0,0,1-.53-1.33,2.4,2.4,0,0,1,.64-1.76v.17a4.52,4.52,0,0,1-.82-1.56,1.76,1.76,0,0,1,.08-1,1.28,1.28,0,0,1,.74-.77l0,.27a1.8,1.8,0,0,1-.78-1.64,2,2,0,0,1,.32-1,1.68,1.68,0,0,1,.81-.65c.3-.13.44-.27.45-.58a2.37,2.37,0,0,1,.21-.91A3.26,3.26,0,0,1,261,101.1c.42-.3.81-.59,1.18-.84a5.17,5.17,0,0,1,1.92-.9,2.79,2.79,0,0,1,.58,0,.55.55,0,0,1,.2,0s-.28,0-.75.14a5.56,5.56,0,0,0-1.82,1l-1.15.87a2.89,2.89,0,0,0-1.06,1.16,2.06,2.06,0,0,0-.18.83.84.84,0,0,1-.18.52,1.12,1.12,0,0,1-.43.31,1.63,1.63,0,0,0-.33,2.77l.27.17-.3.11a1.24,1.24,0,0,0-.63,1.43,4.1,4.1,0,0,0,.75,1.47l.06.09-.08.08a2.21,2.21,0,0,0-.62,1.56,2.1,2.1,0,0,0,.44,1.24A3.11,3.11,0,0,0,259.78,113.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.61,105.64a1.14,1.14,0,0,1-.43-.09,4.17,4.17,0,0,1-1.11-.57,4.34,4.34,0,0,1-1.25-1.47,1.68,1.68,0,0,1-.21-1.21.82.82,0,0,1,.48-.53.63.63,0,0,1,.76.13l-.23.14a2.16,2.16,0,0,1-.22-1.21,1,1,0,0,1,.38-.59.82.82,0,0,1,.72-.1,1.47,1.47,0,0,0,.54.07c.12,0,.14-.18.13-.42a1.92,1.92,0,0,1,.53-1.32,2.06,2.06,0,0,1,2.13-.61l-.2.18a1.77,1.77,0,0,1,.33-1.73,1.09,1.09,0,0,1,.85-.27.82.82,0,0,1,.7.51l-.27.06a4.25,4.25,0,0,1,.54-2.29A4.33,4.33,0,0,1,275,92.94a3.76,3.76,0,0,1,1-.57c.25-.09.39-.12.39-.1a5.91,5.91,0,0,0-1.31.79A4.54,4.54,0,0,0,274,94.42a4.09,4.09,0,0,0-.46,2.17l.07,1.14-.34-1.09c-.12-.37-.77-.43-1.09-.12a1.5,1.5,0,0,0-.23,1.44l.08.28-.28-.09a1.77,1.77,0,0,0-1.8.53,1.59,1.59,0,0,0-.45,1.11,1.23,1.23,0,0,1,0,.37.47.47,0,0,1-.3.34,1.26,1.26,0,0,1-.72-.07.53.53,0,0,0-.47,0,.75.75,0,0,0-.27.42,2,2,0,0,0,.19,1l.29.76-.53-.62c-.2-.25-.72,0-.78.3a1.44,1.44,0,0,0,.17,1,4.3,4.3,0,0,0,1.14,1.44A5.79,5.79,0,0,0,269.61,105.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.34,86.28a3.25,3.25,0,0,1-1.77-1.11,1.74,1.74,0,0,1-.31-1.36,1.62,1.62,0,0,1,.13-.33l.07.22a1.54,1.54,0,0,1-.78-1,1.34,1.34,0,0,1,.21-1c.34-.5.75-.55.74-.52s-.32.17-.56.63a1.22,1.22,0,0,0,.53,1.66l.14.07-.08.15a1.84,1.84,0,0,0-.09.25,1.48,1.48,0,0,0,.24,1.13,2.84,2.84,0,0,0,.72.71C285,86.05,285.37,86.23,285.34,86.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.65,82.89a1.83,1.83,0,0,0,.22-1.14,1.32,1.32,0,0,0-.74-1,1.42,1.42,0,0,0-1.5.23l-.2.19-.05-.27A2.49,2.49,0,0,0,290,80a1.16,1.16,0,0,0-.78-.56c-.5-.07-1.06.39-.93.81l-.29.06a2.43,2.43,0,0,0-.87-1.57,2.32,2.32,0,0,0-1.34-.51,3.6,3.6,0,0,0-1.32.23.82.82,0,0,1,.31-.2,2.38,2.38,0,0,1,1-.23,2.51,2.51,0,0,1,1.51.51,2.64,2.64,0,0,1,1,1.73l-.3.06a.9.9,0,0,1,.31-.91,1.31,1.31,0,0,1,.95-.3,1.47,1.47,0,0,1,1,.71,2.65,2.65,0,0,1,.39,1l-.24-.08a1.66,1.66,0,0,1,1.81-.25,1.49,1.49,0,0,1,.81,1.19,1.55,1.55,0,0,1-.18.92C292.75,82.83,292.66,82.9,292.65,82.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.13,132.37s31.68-.49,41.28,4.69c0,0,3.92-2.15,6.06-1.26s1.9,1.26,1.9,1.26-2-4.08,2.14-2.61,4.3,2.61,4.3,2.61l13-.3.16,2.78c-2.4,2.65-9.09,10-9.09,10l-5.56,20-20.12,82.07-9.27,41.73a72.78,72.78,0,0,1-10.83-29.42c-2.54-17.79,10.31-94.42,10.31-94.42s-49.66-20.56-51.82-29C177,134.45,206.13,132.37,206.13,132.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.18,141.17s9.06,1.71,12,3.88S323,154,323,154s4.87-.38,4.63,4.54c0,0,16.06,7.48,17.1,10.1s27.69,45,27.41,47.32-5.72,19.63-13.08,17.36-26.49-23-26.49-23,8.31,81.39-2.52,88.06l-13.87-17.27-2.54-60Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.18,141.17c2.24,10.48-6.32,14.75-15.6,12.72s-10.7-15.33-10.7-15.33L264,142.37l-9.79,22.2-14,87,75.3,18.73L311,146.9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.2,134.75s-15.24-8.3-19.81-8.91c-7.77-1-23.4-2.37-26.6,5.5s11.72,19.71,31.47,20.29a18.56,18.56,0,0,1,8.88,2.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.59,149.74a48.8,48.8,0,0,0-1.87-6.62,50.31,50.31,0,0,0-3.26-6.07,6.19,6.19,0,0,1,1.35,1.54,20.79,20.79,0,0,1,2.39,4.33,20.45,20.45,0,0,1,1.3,4.77A6,6,0,0,1,252.59,149.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.44,149.53a33.9,33.9,0,0,0,1.21-6.64,33.22,33.22,0,0,0-.68-6.72,5.58,5.58,0,0,1,.7,1.89,17.19,17.19,0,0,1-.38,9.64A6,6,0,0,1,254.44,149.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.82,159.15a4.23,4.23,0,0,1,.33-1c.24-.6.6-1.46,1.06-2.52.92-2.12,2.22-5,3.69-8.24s2.72-6.17,4.21-8a9,9,0,0,1,2-1.92A2.88,2.88,0,0,1,268,137a13.66,13.66,0,0,0-2.59,2.62c-1.37,1.83-2.54,4.81-4,8s-2.82,6.09-3.82,8.17c-.51,1-.92,1.88-1.22,2.45S255.86,159.17,255.82,159.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.27,126.05a2,2,0,0,1,.43.15l1.21.51c1.06.46,2.59,1.15,4.5,2.1a124.41,124.41,0,0,1,15.1,8.85l.17.12-.09.18L216.38,154l-.12.23-.23-.11-.56-.26c-1.36-.6-2.63-1.31-4-1.8a9.13,9.13,0,0,0-4.06-.7,55.82,55.82,0,0,1-8.07,0,26.89,26.89,0,0,1-7.06-2,44.1,44.1,0,0,1-5.75-2.73,32.39,32.39,0,0,1-7.32-5.57,24.57,24.57,0,0,1-1.65-1.88,6.46,6.46,0,0,1-.51-.71,4.75,4.75,0,0,1,.59.64c.37.43.94,1.05,1.72,1.81a33.93,33.93,0,0,0,7.35,5.39,44.49,44.49,0,0,0,5.73,2.65,26.9,26.9,0,0,0,6.95,1.89,58.07,58.07,0,0,0,8-.07c3-.26,5.65,1.35,8.28,2.54l.55.26-.34.12,8.26-16,.08.3a134.76,134.76,0,0,0-15-9c-1.89-1-3.4-1.71-4.43-2.21l-1.18-.58A2.14,2.14,0,0,1,203.27,126.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.6,163.4a15.94,15.94,0,0,1-.25-3.16c-.06-2,0-4.67-.13-7.64-.06-1.49-.16-2.9-.32-4.17a10,10,0,0,0-.8-3.26,4.52,4.52,0,0,0-1.42-1.7c-.44-.31-.73-.4-.72-.44a1.53,1.53,0,0,1,.83.26,4.34,4.34,0,0,1,1.63,1.71,9.63,9.63,0,0,1,1,3.36c.18,1.29.3,2.72.36,4.22.1,3,0,5.7,0,7.66A25.25,25.25,0,0,1,311.6,163.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,159a56.18,56.18,0,0,1-6.89-3.45,55.84,55.84,0,0,1-6.63-3.91,57.33,57.33,0,0,1,6.88,3.45A57.57,57.57,0,0,1,328,159Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.26,134.33a25,25,0,0,0-2.62,1.3,12.32,12.32,0,0,0-4.46,5.24,18.09,18.09,0,0,0-1.48,6.82c-.06,1.81.06,2.93,0,2.94a2.29,2.29,0,0,1-.17-.78,17.23,17.23,0,0,1,1.21-9.19,11.9,11.9,0,0,1,4.74-5.35,9,9,0,0,1,2-.85A2.13,2.13,0,0,1,218.26,134.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.6,147.32a5,5,0,0,1-2.68-.45,5.17,5.17,0,0,1-2.35-1.37,11.79,11.79,0,0,1,2.53.88A13.15,13.15,0,0,1,214.6,147.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.28,144a6.46,6.46,0,0,1-2.62-.8,6.54,6.54,0,0,1-2.35-1.42,20,20,0,0,1,5,2.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.84,140.94a6.57,6.57,0,0,1-2.34-1,6.4,6.4,0,0,1-2.09-1.46,6.23,6.23,0,0,1,2.34,1C216,140.16,216.91,140.81,216.84,140.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.56,138.81c-.12.09-.87-.88-2.05-1.76s-2.31-1.34-2.27-1.48a5.61,5.61,0,0,1,4.32,3.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.31,143.28c.05,0-.15.65-.37,1.83s-.4,2.91-.92,5a9.7,9.7,0,0,1-1.47,3.26,8.29,8.29,0,0,1-3.18,2.6,16.63,16.63,0,0,1-9.17,1.47,16.81,16.81,0,0,1-8.58-3.57,17.06,17.06,0,0,1-4.66-6,16.14,16.14,0,0,1-1.42-4.93,10.24,10.24,0,0,1-.09-1.39,1.75,1.75,0,0,1,0-.48s.07.66.27,1.85a17.6,17.6,0,0,0,1.55,4.79,17.12,17.12,0,0,0,4.63,5.79,16.8,16.8,0,0,0,17.24,2,8.13,8.13,0,0,0,3-2.42,9.53,9.53,0,0,0,1.46-3.11c.56-2.06.78-3.81,1.08-5a12.85,12.85,0,0,1,.39-1.34A1.65,1.65,0,0,1,303.31,143.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.16,160.68H362.42a13,13,0,0,1,13,13v100.2a13,13,0,0,1-13,13H187.16a12,12,0,0,1-12-12V172.67a12,12,0,0,1,12-12Z",
    transform: "translate(18.91 -21.44) rotate(4.62)",
    style: {
      fill: "#F2A413"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "174.54 227.59 379.33 179.57 378.07 195.11 172.83 248.8 174.54 227.59"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "289.48 161.65 307.17 211.69 324.44 291.11 342.95 292.61 313.18 199.84 306.07 162.99 289.48 161.65"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M201.54,260.3l2.41.2-.37,4.62a7.93,7.93,0,0,1-4.73,1.07c-3.58-.29-6-3-5.74-6.39s3.11-5.68,6.74-5.39a6.11,6.11,0,0,1,4.61,2.36l-1.82,1.42a3.84,3.84,0,0,0-2.84-1.52,3.66,3.66,0,1,0-.62,7.29,4.22,4.22,0,0,0,2.09-.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.84,255.18l2.63.21-.92,11.39-2.63-.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.64,257.94l-.24,3,5.27.42-.17,2.12-5.27-.43-.34,4.15-2.63-.21.92-11.39,8.6.69-.17,2.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.84,258.79l-3.64-.29.17-2.15,9.93.8-.17,2.15-3.65-.29-.75,9.24L224.1,268Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.41,263.3a5.7,5.7,0,0,1,6.37-5.3,5.45,5.45,0,0,1,3.92,1.9l-.56.5a4.79,4.79,0,0,0-3.39-1.64,5,5,0,1,0-.81,10,4.78,4.78,0,0,0,3.61-1.08l.48.57a5.45,5.45,0,0,1-4.18,1.27A5.7,5.7,0,0,1,236.41,263.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.69,267.36l-6.61-.53-1.71,3.09-.89-.08,6.16-11,.83.06,4.32,11.82-.9-.07Zm-.26-.72L253,259.82l-3.51,6.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.77,271.56l-2.41-4a8.4,8.4,0,0,1-1.12,0l-3.25-.27-.3,3.73-.83-.06.92-11.4,4.08.33c2.87.24,4.47,1.81,4.28,4.21a3.5,3.5,0,0,1-3,3.35l2.53,4.22Zm-3.47-4.76c2.44.19,3.84-.84,4-2.79s-1.05-3.2-3.49-3.4l-3.25-.26-.5,6.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.49,260.48l4.51.36c3.61.3,5.86,2.87,5.6,6.19s-2.91,5.5-6.52,5.21l-4.51-.37Zm3.59,11c3.22.26,5.45-1.62,5.69-4.52s-1.67-5.11-4.89-5.37l-3.62-.29-.8,9.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.52,281.37c0,.14-27.44-1.88-61.25-4.52S192,272,192,271.82s27.44,1.88,61.27,4.51S314.54,281.23,314.52,281.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.34,199.22c-3.51.83-7.2.18-10.63-.92s-6.71-2.63-10.17-3.63a34.83,34.83,0,0,0-25.55,2.6,2,2,0,0,0-.94.79,2,2,0,0,0,0,1.39l8.52,30.91a5.32,5.32,0,0,0,1.5,2.87c1.24,1,3,.64,4.56.24a72.48,72.48,0,0,0,14.37-5,29.68,29.68,0,0,0,11.52-9.74c1.31-2,2.31-4.16,3.68-6.1a9.93,9.93,0,0,1,5.55-4.21Z",
    style: {
      fill: "#F2A413"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.51,209.54c-2.24-13.14-4.49-26.35-8.84-38.94-8.73-.18-17,4.07-23.93,9.38s-13,11.72-20,16.93l.1,9.43a12.7,12.7,0,0,1,8-.05,46.73,46.73,0,0,1,7.45,3.15,61.29,61.29,0,0,0,17.55,5.85c6.12.89,12.6.27,18.06-2.64a3,3,0,0,0,1.63-1.53A3.25,3.25,0,0,0,364.51,209.54Z",
    style: {
      fill: "#F2A413"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M302.34,199.22c-3.51.83-7.2.18-10.63-.92s-6.71-2.63-10.17-3.63a34.83,34.83,0,0,0-25.55,2.6,2,2,0,0,0-.94.79,2,2,0,0,0,0,1.39l8.52,30.91a5.32,5.32,0,0,0,1.5,2.87c1.24,1,3,.64,4.56.24a72.48,72.48,0,0,0,14.37-5,29.68,29.68,0,0,0,11.52-9.74c1.31-2,2.31-4.16,3.68-6.1a9.93,9.93,0,0,1,5.55-4.21Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M302.34,199.22l.18.57c.12.42.28,1,.5,1.74l1.9,6.82,0,.12-.12,0a8.69,8.69,0,0,0-4.17,2.61,25.06,25.06,0,0,0-3.34,5,27.16,27.16,0,0,1-4,5.74,29.57,29.57,0,0,1-6,5c-4.6,3-10.25,4.93-16.27,6.54-1.49.36-3,1-4.76.69a3.16,3.16,0,0,1-2.1-1.44,8.8,8.8,0,0,1-.89-2.34c-.87-3.15-1.76-6.38-2.67-9.65-1.33-4.82-2.62-9.53-3.88-14.08-.62-2.27-1.24-4.51-1.84-6.69a3,3,0,0,1-.14-1.82,2.63,2.63,0,0,1,1.4-1.13c1-.51,2-1,3-1.36a34.8,34.8,0,0,1,12.09-2.38A34.19,34.19,0,0,1,282,194.61c3.15,1,5.86,2.18,8.31,3a30.5,30.5,0,0,0,6.42,1.68,17.3,17.3,0,0,0,4.19.09c.95-.11,1.48-.23,1.46-.21a2.24,2.24,0,0,1-.37.11,10.63,10.63,0,0,1-1.07.2,16.15,16.15,0,0,1-4.23,0,29.83,29.83,0,0,1-6.5-1.61c-2.47-.84-5.19-2-8.32-3a34.78,34.78,0,0,0-22.45,1c-1,.4-2,.84-3,1.34-.5.25-1,.49-1.17.89a2.51,2.51,0,0,0,.16,1.49q.91,3.28,1.86,6.7c1.25,4.54,2.55,9.25,3.89,14.07q1.35,4.92,2.66,9.65a7.9,7.9,0,0,0,.83,2.21,2.63,2.63,0,0,0,1.76,1.21c1.49.27,3-.3,4.53-.67,6-1.59,11.61-3.54,16.16-6.44a29.64,29.64,0,0,0,5.94-4.86,28,28,0,0,0,4-5.64,24.5,24.5,0,0,1,3.42-5,8.88,8.88,0,0,1,4.34-2.65l-.1.16c-.75-2.93-1.34-5.21-1.74-6.78l-.45-1.78C302.38,199.45,302.34,199.22,302.34,199.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M364.51,209.54c-2.24-13.14-4.49-26.35-8.84-38.94-8.73-.18-17,4.07-23.93,9.38s-13,11.72-20,16.93l.1,9.43a12.7,12.7,0,0,1,8-.05,46.73,46.73,0,0,1,7.45,3.15,61.29,61.29,0,0,0,17.55,5.85c6.12.89,12.6.27,18.06-2.64a3,3,0,0,0,1.63-1.53A3.25,3.25,0,0,0,364.51,209.54Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M364.51,209.54a3.43,3.43,0,0,1,.15,1.09,1.84,1.84,0,0,1-.54,1.24,5.17,5.17,0,0,1-1.54,1,26.87,26.87,0,0,1-11.5,2.9c-5.11.25-11.28-.91-17.73-3.46q-2.42-1-4.91-2.11c-1.67-.76-3.34-1.62-5.08-2.39a22.48,22.48,0,0,0-5.52-1.74,11.38,11.38,0,0,0-5.89.47l-.34.13v-.36c0-3-.07-6.18-.11-9.43v-.13l.11-.08c3.3-2.46,6.54-5.31,9.81-8.25,5.36-4.83,10.64-9.56,16.44-12.89s12-5.33,17.81-5.19h.16l.05.14a192.15,192.15,0,0,1,6.87,28.16c.61,3.45,1.05,6.16,1.35,8,.14.91.25,1.61.32,2.12,0,.22.06.4.08.54a.69.69,0,0,1,0,.19s0-.06-.05-.18l-.11-.54q-.14-.75-.39-2.1c-.34-1.88-.84-4.57-1.47-8a200.82,200.82,0,0,0-7-28.06l.2.15c-5.72-.12-11.86,1.83-17.55,5.17s-11,8-16.34,12.85c-3.28,2.94-6.53,5.8-9.86,8.27l.11-.21c0,3.25.06,6.43.09,9.43l-.34-.23a12,12,0,0,1,6.14-.48,22.8,22.8,0,0,1,5.64,1.79c1.76.78,3.42,1.65,5.08,2.41s3.27,1.48,4.88,2.12a43.68,43.68,0,0,0,17.56,3.54,27.26,27.26,0,0,0,11.44-2.73,5.24,5.24,0,0,0,1.52-1,1.77,1.77,0,0,0,.54-1.15A10.44,10.44,0,0,0,364.51,209.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.14,210.31s-2.39.39-4.3,7.09-5.77,37.79-5.77,37.79l29.73,7.95L313,211.25Z",
    style: {
      fill: "#F2A413"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.09,210.22l17.49,33.62L348,224.06s-19.56-17.21-32-16.9Z",
    style: {
      fill: "#F2A413"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M306.14,210.31s-2.39.39-4.3,7.09-5.77,37.79-5.77,37.79l29.73,7.95L313,211.25Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M315.09,210.22l17.49,33.62L348,224.06s-19.56-17.21-32-16.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M306.14,210.31a2.43,2.43,0,0,1,.44,0l1.31.15,5.14.65h.08l0,.08c2.39,9.38,7.22,28.77,12.92,51.85l.1.42-.42-.11-8.29-2.22L296,255.42l-.21,0,0-.21c1.74-13.53,3.37-25.12,4.9-33.27a27.57,27.57,0,0,1,2.94-9.22,7,7,0,0,1,1.67-2,2.66,2.66,0,0,1,.59-.33c.14-.05.22-.06.22-.05l-.21.09a2.75,2.75,0,0,0-.54.36,7.18,7.18,0,0,0-1.59,2A28.37,28.37,0,0,0,301,222c-1.44,8.15-3,19.74-4.71,33.27l-.18-.27,21.44,5.72,8.29,2.22-.31.31c-5.68-23.08-10.4-42.5-12.64-51.92l.09.08-5.11-.75-1.31-.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.09,210.22s0-.06,0-.19l.15-.59.66-2.3,0-.06H316c3-.17,8,1.07,13.58,4a102.17,102.17,0,0,1,18.6,12.8l.18.16-.15.19-7.07,9.06L332.78,244l-.25.31-.18-.35-12.46-24.17-3.57-7-.94-1.88a3.44,3.44,0,0,1-.29-.66s.14.22.38.65l1,1.86c.88,1.67,2.14,4,3.71,7,3.15,6,7.53,14.35,12.6,24l-.42,0L340.75,233l7.08-9.05,0,.34a105.43,105.43,0,0,0-18.44-12.84c-5.57-2.95-10.43-4.25-13.39-4.16l.08-.06-.74,2.25c-.08.23-.14.43-.2.58A1.08,1.08,0,0,1,315.09,210.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.77,206.22c0,.07-1.35.34-3.53.85s-5.17,1.29-8.41,2.36-6.09,2.26-8.13,3.19a35,35,0,0,1-3.31,1.47,3.51,3.51,0,0,1,.81-.54c.54-.33,1.34-.76,2.34-1.27a63.63,63.63,0,0,1,8.13-3.34,65.1,65.1,0,0,1,8.49-2.23c1.11-.21,2-.36,2.63-.43A3.05,3.05,0,0,1,302.77,206.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.7,203a30.85,30.85,0,0,1-3.37.11,70.79,70.79,0,0,0-8.08.63c-3.13.44-5.94,1.05-8,1.51a27.15,27.15,0,0,1-3.3.67,3.23,3.23,0,0,1,.84-.33c.56-.19,1.37-.43,2.37-.7a64.38,64.38,0,0,1,8-1.66,51.85,51.85,0,0,1,8.15-.49c1,0,1.89.07,2.47.12A3.11,3.11,0,0,1,301.7,203Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.55,191.9c0,.09-1.59.08-4.16.3a49.19,49.19,0,0,0-9.84,1.84,46.64,46.64,0,0,0-9.21,3.92c-2.23,1.27-3.53,2.2-3.59,2.12a5.53,5.53,0,0,1,.87-.72,25.76,25.76,0,0,1,2.54-1.71,39.79,39.79,0,0,1,9.24-4.11,42.84,42.84,0,0,1,10-1.71c1.29-.06,2.34-.07,3.06,0A5,5,0,0,1,343.55,191.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,200.88a3.81,3.81,0,0,1-.92.33c-.59.19-1.46.42-2.55.67a58.14,58.14,0,0,1-8.62,1.31,57.1,57.1,0,0,1-8.72,0c-1.11-.1-2-.2-2.63-.3a3.86,3.86,0,0,1-.95-.19,35.4,35.4,0,0,1,3.6.12,75.1,75.1,0,0,0,8.66-.15,80.67,80.67,0,0,0,8.58-1.15A35.12,35.12,0,0,1,342,200.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,204a17.45,17.45,0,0,0-1.94-5.13c-.75-1.41-1-2.81-3-3.56a6,6,0,0,0-5.26,1c-1.3-1.21-3.46-.52-4.86.57a5.72,5.72,0,0,0-2,4.75,11.22,11.22,0,0,0,1.68,5,13,13,0,0,0,5.44,5.41,6.92,6.92,0,0,0,6.66-.38A7.28,7.28,0,0,0,318,204Z",
    style: {
      fill: "#F2A413"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M318,204a17.45,17.45,0,0,0-1.94-5.13c-.75-1.41-1-2.81-3-3.56a6,6,0,0,0-5.26,1c-1.3-1.21-3.46-.52-4.86.57a5.72,5.72,0,0,0-2,4.75,11.22,11.22,0,0,0,1.68,5,13,13,0,0,0,5.44,5.41,6.92,6.92,0,0,0,6.66-.38A7.28,7.28,0,0,0,318,204Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M318,204a2.08,2.08,0,0,1,.14.56,8.15,8.15,0,0,1,.07,1.62,7.23,7.23,0,0,1-6.59,6.76,7.41,7.41,0,0,1-4.61-1.2,13,13,0,0,1-3.76-3.7,14.43,14.43,0,0,1-2.37-5.14,6.4,6.4,0,0,1,1.63-6,6.26,6.26,0,0,1,2.67-1.4,3,3,0,0,1,2.8.61h-.33a5.47,5.47,0,0,1,3.25-1.26,4.71,4.71,0,0,1,3.07.63,4.62,4.62,0,0,1,1.72,2.18c.33.77.7,1.43,1,2.08a15.7,15.7,0,0,1,1.12,3.07,6.58,6.58,0,0,1,.17.85c0,.19,0,.29,0,.29s-.11-.39-.33-1.1a18.83,18.83,0,0,0-1.23-3c-.31-.61-.71-1.3-1.06-2.06a4.25,4.25,0,0,0-1.61-2,4.38,4.38,0,0,0-2.83-.53,5.15,5.15,0,0,0-3,1.16l-.16.16-.16-.15a2.56,2.56,0,0,0-2.37-.48,5.73,5.73,0,0,0-2.43,1.29,5.91,5.91,0,0,0-1.47,5.49,14,14,0,0,0,2.28,4.95,12.74,12.74,0,0,0,3.59,3.58,7,7,0,0,0,4.33,1.18,6.8,6.8,0,0,0,3.67-1.4,7.06,7.06,0,0,0,2.75-4.94A15.91,15.91,0,0,0,318,204Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.51,211.13c-.07-.06.5-.75,1.17-2a13.55,13.55,0,0,0,1-10.65c-.43-1.35-.87-2.12-.79-2.17a5.89,5.89,0,0,1,1.14,2.05,12.44,12.44,0,0,1,.78,5.59,12.27,12.27,0,0,1-1.79,5.36A6.06,6.06,0,0,1,306.51,211.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.75,200.08a6.22,6.22,0,0,1-.18,2.16,15.41,15.41,0,0,1-1.84,4.88,14.69,14.69,0,0,1-3.39,4,5.86,5.86,0,0,1-1.83,1.15,22.49,22.49,0,0,0,4.77-5.38C316.32,203.4,316.57,200,316.75,200.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.5,201a8.73,8.73,0,0,1-1.42-.31l-3.84-1a90.89,90.89,0,0,0-12.8-2.61,41.64,41.64,0,0,0-13,.38,32.81,32.81,0,0,0-3.82,1,11,11,0,0,1-1.4.43,6.44,6.44,0,0,1,1.33-.62,26.15,26.15,0,0,1,3.81-1.18,38.81,38.81,0,0,1,13.11-.54,78.83,78.83,0,0,1,12.84,2.77c1.61.47,2.9.88,3.79,1.17A8.46,8.46,0,0,1,293.5,201Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.48,205.65a25,25,0,0,1-3.93.65,24.2,24.2,0,0,1-3.95.53,17.65,17.65,0,0,1,7.88-1.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.55,212.09c.06.13-.6.55-1.47.94s-1.62.59-1.68.46.6-.55,1.47-.94S286.49,212,286.55,212.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.45,204.69c-.05,0-.37-.37-.67-1.13a7,7,0,0,1-.41-3.17,7,7,0,0,1,1-3c.45-.69.84-1,.89-1a12,12,0,0,0-1.38,4.05A12.53,12.53,0,0,0,303.45,204.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.38,206.15a13.07,13.07,0,0,1,.11-2.28,12.13,12.13,0,0,1,0-2.28,5,5,0,0,1-.15,4.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.38,183.21a84.35,84.35,0,0,1-7.11,5.82,83,83,0,0,1-7.42,5.4,82.11,82.11,0,0,1,7.11-5.82A83,83,0,0,1,331.38,183.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.1,196.64a12.63,12.63,0,0,1-4.58,2.23,6.53,6.53,0,0,1,2.18-1.35A6.27,6.27,0,0,1,326.1,196.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.19,223.47a15.14,15.14,0,0,1,.3-5.77,14.94,14.94,0,0,1,2-5.43c.14.06-.84,2.44-1.46,5.53S303.34,223.47,303.19,223.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,221.54a39.58,39.58,0,0,1-3.85-8.23,19.81,19.81,0,0,1,2.16,4A20.29,20.29,0,0,1,324,221.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.51,167.92c0,.15-6.16-.45-13.71-1.32s-13.67-1.7-13.66-1.84,6.16.45,13.72,1.32S227.53,167.78,227.51,167.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.73,209.53v-3.44a4.24,4.24,0,0,0-4.67-3.75l-6.78.67-3.85,2.41a2,2,0,0,0,2,2.23l-5.16,1.95a1.91,1.91,0,0,0,2,2.54l-2.14,1.15a2.59,2.59,0,0,0,3,3s-1.56,1.55,2,2.37a25.66,25.66,0,0,0,4.65.82l2.09,2.79-.2,2.51s3.37.39,4-.94a12.14,12.14,0,0,0,.65-4,2.7,2.7,0,0,0,2.38-2.87,4.18,4.18,0,0,0,.7-5.08A19.63,19.63,0,0,1,382.73,209.53Z",
    style: {
      fill: "#be8671"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.92,219.19c-.08,0-.45-.71-1.23-1.77a6.3,6.3,0,0,0-1.63-1.57,4.65,4.65,0,0,0-2.56-.8c-1,0-2,.21-2.84.28a17,17,0,0,0-2.29.38,15.26,15.26,0,0,1-2.11.48,7,7,0,0,1,2-.84,14.2,14.2,0,0,1,2.33-.5c.88-.09,1.82-.29,2.89-.32a5,5,0,0,1,2.83.92,6.34,6.34,0,0,1,1.67,1.76A5.77,5.77,0,0,1,379.92,219.19Z",
    style: {
      fill: "#a24c2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.12,215.33a14.75,14.75,0,0,1-1.74-2.2,15.29,15.29,0,0,0-1.87-2.31,2.86,2.86,0,0,0-1.47-.68,5.8,5.8,0,0,0-1.83.13c-2.54.63-4.86,1.22-6.54,1.6a15.44,15.44,0,0,1-2.75.52,14.55,14.55,0,0,1,2.66-.88c1.66-.47,4-1.12,6.53-1.75a5.86,5.86,0,0,1,2-.12,3.23,3.23,0,0,1,1.72.82,12.75,12.75,0,0,1,1.85,2.47A16.7,16.7,0,0,1,382.12,215.33Z",
    style: {
      fill: "#a24c2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.83,208.89c0,.07-.79-.33-1.7-1.29a7,7,0,0,0-1.72-1.38,4,4,0,0,0-2.6-.14,57.36,57.36,0,0,1-7,1.69,8.84,8.84,0,0,1,2-.76c1.25-.39,3-1,4.92-1.45a4.43,4.43,0,0,1,2.91.23,6.35,6.35,0,0,1,1.78,1.56C381.23,208.36,381.86,208.83,381.83,208.89Z",
    style: {
      fill: "#a24c2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.69,147.85l4.6,1.64s3.07,10.24,4.71,10.44,3.69,2.26,5.33.41c0,0,2.35,1.85,3.68-.2,0,0,4.92.92,5.43-.51l.51-1.44s8,10,9.63,10,2-.93,1.43-2.15-8.5-14.13-10.34-16.28S229.53,137.51,222,137.51c0,0-5.43,2.46-6.76,6.25S214.69,147.85,214.69,147.85Z",
    style: {
      fill: "#be8671"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.35,137.2a27.34,27.34,0,0,0-2.87,1.19A11,11,0,0,0,215,151a27.71,27.71,0,0,0,1.08,2.91s-.22-.21-.51-.68a10,10,0,0,1-.92-2.13,10.84,10.84,0,0,1,5.7-13,9.68,9.68,0,0,1,2.19-.77A2.6,2.6,0,0,1,223.35,137.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.27,155.28a6.84,6.84,0,0,1,1.07,1.24c.62.79,1.47,1.9,2.39,3.12l2.34,3.16a7.41,7.41,0,0,1,.92,1.35c-.14.13-1.84-1.73-3.68-4.19S237.12,155.38,237.27,155.28Z",
    style: {
      fill: "#a24c2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,158.76c.12-.09.46.16.76.56s.46.8.35.88-.46-.16-.76-.56S231.89,158.84,232,158.76Z",
    style: {
      fill: "#a24c2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.28,159.6c.14,0,.32.12.47.34s.25.45.16.56-.39,0-.59-.27S228.15,159.64,228.28,159.6Z",
    style: {
      fill: "#a24c2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.92,151.91c.06,0,.17.15.17.46a1.48,1.48,0,0,1-.53,1.07,1.46,1.46,0,0,1-1.14.33c-.31-.05-.46-.19-.43-.25s.7,0,1.24-.48S239.78,151.92,239.92,151.91Z",
    style: {
      fill: "#a24c2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.86,155.81c.07,0,.08.22-.05.5a1.93,1.93,0,0,1-2,1c-.3-.07-.45-.2-.43-.27s.7,0,1.37-.36S234.72,155.77,234.86,155.81Z",
    style: {
      fill: "#a24c2c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358,130.28,379.61,125l-.16,0a36.06,36.06,0,0,0,18.68,5.6,39.31,39.31,0,0,0,11.58-1.69,35.77,35.77,0,0,0,11.28-6,36.3,36.3,0,0,0,13.65-24.13,36.5,36.5,0,0,0-15.57-34.35c-1.17-.73-2.32-1.48-3.53-2.11l-1.84-.89-.91-.44-1-.35a36.63,36.63,0,0,0-15.56-2.37,36,36,0,0,0-31.76,24.25,37.49,37.49,0,0,0-2,11.69,35.85,35.85,0,0,0,5.19,18.75v-.2c-6,10.86-9.06,16.35-9.73,17.56L368,112.91l.06-.09-.06-.1a35.71,35.71,0,0,1-5-18.55,36.94,36.94,0,0,1,2-11.5,35.13,35.13,0,0,1,6.33-11.14,35.67,35.67,0,0,1,40.18-10.26l.94.34.9.43,1.8.87c1.18.62,2.31,1.36,3.46,2.07a36.66,36.66,0,0,1,6.14,5.35,35.54,35.54,0,0,1-4.21,52,35.42,35.42,0,0,1-11.07,5.92A38.74,38.74,0,0,1,398.14,130a35.63,35.63,0,0,1-18.47-5.41l-.08,0-.08,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.68,78.29l-1.14,18.08a3,3,0,0,1-2.76,2.74h0a2.94,2.94,0,0,1-3.09-2.61l-2-18.17A2.29,2.29,0,0,1,395,75.78l4.41.06A2.3,2.3,0,0,1,401.68,78.29Z",
    style: {
      fill: "#F2A413"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,109.28a4.41,4.41,0,1,0,2.8-5.58A4.43,4.43,0,0,0,393,109.28Z",
    style: {
      fill: "#F2A413"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCardPana);
export default __webpack_public_path__ + "static/media/gift-card-pana.08ee7714c052a656c0bf38c0fe7d4849.svg";
export { ForwardRef as ReactComponent };